import { render, staticRenderFns } from "./AdjustOversoldRatio.vue?vue&type=template&id=d05da7f6&"
import script from "./AdjustOversoldRatio.vue?vue&type=script&lang=js&"
export * from "./AdjustOversoldRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports